import { customTranslations } from "./translations";

import get from "lodash/get";

/**
 * Retrieves the application's locale from the current URL.
 * This function parses the URL of the current page and extracts the locale parameter.
 * The locale is typically represented as a two-letter code (e.g., "en" for English).
 * If a valid locale parameter is found in the URL, it is returned. Otherwise, the function
 * falls back to a default locale ("en" for English).
 * @returns {string} The extracted locale code from the URL, or the default locale if not found.
 */
export const getAppLocale = () => {
  const url = window.location.href;
  const parts = url.replace(/\/$/, "").split("/");

  // Find the index of the part containing the locale (e.g., "en")
  const localeIndex = parts.findIndex((part) => /^[a-z]{2}$/.test(part));

  if (localeIndex !== -1) {
    return parts[localeIndex];
  } else {
    return "en";
  }
};

/**
 * Formats a game link with the appropriate locale-specific prefix.
 * This function takes a game link as input and generates a fully formatted link
 * based on the current locale. It first determines the current locale using the
 * `getAppLocale` function. Then, it constructs a game link by appending the locale-specific
 * game link prefix obtained from custom translations to the provided gameLink parameter.
 * @param {string} gameLink - The game link.
 * @returns {string} The fully formatted URL for the game.
 */
export const formatGameLink = (gameLink) => {
  const locale = getAppLocale();
  const currentHost = window?.location?.hostname;

  const gameLinkPrefix = get(
    customTranslations,
    `${locale}.translation["play_online"]`
  );
  const fullGameLink = `https://${currentHost}/${locale}/${gameLinkPrefix}${gameLink}`;

  return fullGameLink;
};
